export default {
  "Loop as a GIF": "Зациклить как GIF",
  "without sound": "без звука",
  "Final output duration": "Конечная выходная длительность",
};
